// NOTE : do not edit this file
//
// it is auto-generated to update the prefix to a value that matches the environment
// if you do want to change this file, remember to update the build pipeline accordingly

export const prefixHolder = {
  Gateway: 'https://id.chatclb.dev',
  Backend: 'https://api.chatclb.dev',
  WebFrontend: 'https://chatclb.dev',
  WebAdminFrontend: "https://admin.chatclb.dev",
  WebSocket: 'wss://api.chatclb.dev',
};

export const oneSignalAdminAppId = '47a69d00-cda8-457a-a77e-3ecb20ab289c'; 